import React from 'react';
import { PolicyFromText } from '../../components/ui/PolicyFromText';
import { privacyPolicy } from '../../data/policies/privacy';
export function Privacy() {
  return <PolicyFromText doc={privacyPolicy} data-id="element-1131" data-mp="czq9xzxutyj4" />;
}